import { Component, effect, inject, input } from '@angular/core';
import { PortfolioSeriesSummary } from 'src/app/models/classes/portfolio-series-summary.class';
import { CurrencyFormatPipe } from 'src/app/pipes/currency-format.pipe';
import { BURNT_ORANGE, CHARCOAL_GREY, GROSVENOR_BLUE } from '@gcm/gcm-ui-angular';
import { BaseWidgetComponent } from '../../base-widget/base-widget.component';
import { GcmChartComponent } from '../../gcm-chart/gcm-chart.component';
import { DataTableCore } from 'highcharts';
@Component({
  selector: 'app-series-distributions-widget',
  imports: [
    BaseWidgetComponent,
    GcmChartComponent,
  ],
  templateUrl: './series-distributions-widget.component.html',
  styleUrl: './series-distributions-widget.component.scss'
})
export class SeriesDistributionsWidgetComponent {
  private currencyFormat = inject(CurrencyFormatPipe);

  readonly series = input<PortfolioSeriesSummary | undefined>(undefined);
  readonly portfolioId = input<number | undefined>(undefined);
  readonly currency = input<string | undefined>(undefined);
  chartConfig!: DataTableCore;
  cumulativeChartStyle = { width: '100%', display: 'flex' };

  private readonly rebuildChart = effect(() => {
    this.series();
    if (this.series()) {
      this.buildWidget();
    }
  });

  buildWidget() {
    const navDistributionData: [string, number][] = [];
    const navTitle = 'Net Asset Value';
    const seriesData = this.series() as PortfolioSeriesSummary;
    const currency = seriesData.currency ?? this.currency();
    const distributions = Number(seriesData.distributions);
    const nav = Number(seriesData.nav);
    const disAndNavSum = distributions + nav;
    const disAndNavSumValToShow = this.currencyFormat.transform(disAndNavSum, currency);
    const distributionsFormatted = this.currencyFormat.transform(distributions, currency);
    const navFormatted = this.currencyFormat.transform(nav, currency);
    navDistributionData.push(['Distributions', seriesData.distributions as number], [navTitle, seriesData.nav as number]);
    this.chartConfig = {
      chart: {
        type: 'pie',
        height: 190,
        margin: 0,
        backgroundColor: '#fbfbfb',
        marginRight: 90,
        marginTop: 10,
        marginLeft: -40
      },
      xAxis: {
        visible: false
      },
      yAxis: {
        visible: false
      },
      title: {
        verticalAlign: 'middle',
        x: -65,
        y: 20,
        style: {
          fontSize: '13px'
        },
        text: `<div style="color: ${CHARCOAL_GREY}; text-align: center;" id="totalValueForChart"><span style="font-weight: 700;">${disAndNavSumValToShow}</span><br/><span style="font-weight: 400;">Total Value</span></div>`,
        useHTML: true
      },
      legend: {
        shadow: false,
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        itemMarginTop: 13,
        labelFormatter: function (this: Highcharts.Point | Highcharts.Series) {
          if (this.name === "Distributions") {
            return `<b><div style="color: ${BURNT_ORANGE}"><span>` + distributionsFormatted + '</b></span><br/><span style="font-weight: 400;">' + this.name + '</span></div>';
          }
          if (this.name === navTitle) {
            return `<b><div style="color: ${GROSVENOR_BLUE}"><span>` + navFormatted + ' </b></span><br/><span style="font-weight: 400;">' + this.name + '</span></div>';
          }
        },
        events: {
          itemClick: () => false
        }
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          innerSize: '70%',
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1
            }
          },
          colors: [BURNT_ORANGE, GROSVENOR_BLUE]
        }
      },
      series: [{
        data: navDistributionData,
        type: 'pie',
        showInLegend: true,
        dataLabels: {
          enabled: false
        }
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 425
          },
          chartOptions: {
            chart: {
              height: 130
            },
            title: {
              style: {
                fontSize: '10px'
              }
            }
          }
        }]
      }
    }
  }
}
